import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Otsi sarnaseid

  <span style="color:#85c1dc;">**FI:**</span>
  Etsi samanlaisia

  <span style="color:#85c1dc;">**RU:**</span>
  Найдите похожие
*/
/* @__NO_SIDE_EFFECTS__ */
const m1939 = msg(
  mf`Otsi sarnaseid`,
  mf`Etsi samanlaisia`,
  mf`Найдите похожие`,
)

export { m1939 as 'w.module.product.use_wordless_search.short' }